document.addEventListener("DOMContentLoaded", function() {
  const dropdownToggles = document.querySelectorAll(".header-dropdown__toggle");

  function showDropdown(toggle) {
    const parentDropdown = toggle.closest(".header-dropdown");

    // Close all other dropdowns
    document.querySelectorAll(".header-dropdown.is-open").forEach(dropdown => {
      if (dropdown !== parentDropdown) dropdown.classList.remove("is-open");
    });

    // Toggle clicked dropdown
    parentDropdown.classList.toggle("is-open");
  }

  // Bind click on toggles
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener("click", function(e) {
      e.stopPropagation(); // Prevent immediate close
      showDropdown(this);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function() {
    document.querySelectorAll(".header-dropdown.is-open").forEach(dropdown => {
      dropdown.classList.remove("is-open");
    });
  });
});
